import { MobileLazyComponents } from './components/MobileLazyComponents';
export class PackageMobileLazy {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    components = new MobileLazyComponents();
}
